import { DataCard } from '../../../components/DashboardCard';
import { useMenuCheckouts } from '../../../hooks/Dashboard/useMenuCheckouts';

export const CheckoutsCard = (props: DashboardCheckoutsCardProps) => {
  const { theme, hideLateCheckout } = props;
  const { menuCheckouts, getMenuCheckouts, loading } = useMenuCheckouts();

  const checkoutsOnly = menuCheckouts.filter(
    (m) => m.id.toLocaleLowerCase() === 'express checkout'
  );

  return (
    <DataCard
      data={hideLateCheckout ? checkoutsOnly : menuCheckouts}
      title="Menu Checkouts"
      views={hideLateCheckout ? ['basic', 'list'] : ['basic', 'list', 'pie']}
      columns={[
        { name: 'Checkout Type', dataKey: 'id' },
        { name: 'Total', dataKey: 'value', isNumeric: true },
      ]}
      orientation="column"
      bottomLabel="Checkout Type"
      leftLabel="Total"
      refresh={true}
      loading={loading}
      onRefresh={getMenuCheckouts}
      enableTimespan
      theme={theme}
    />
  );
};
